import React from 'react';
import { PERSONAL_INFO, SOCIAL_LINKS } from '../constants/data';

const Hero = () => {
  const [firstName, ...restOfName] = PERSONAL_INFO.name.split(' ');
  const lastName = restOfName.join(' ');

  return (
    <section id="home" className="hero">
      <div className="container hero__grid">
        <div className="hero__content">
          <div className="hero__status">
            <span className="hero__status-dot" />
            {PERSONAL_INFO.status}
          </div>

          <h1 className="hero__name">
            {firstName}
            <br />
            {lastName}<span className="accent">.</span>
          </h1>

          <p className="hero__role">
            <span className="accent-mono">&#123;</span> {PERSONAL_INFO.title}{' '}
            <span className="accent-mono">&#125;</span>
          </p>

          <p className="hero__desc">{PERSONAL_INFO.description}</p>

          <div className="hero__actions">
            <a href="#work" className="btn btn--solid">
              View my work
            </a>
            <a href="#contact" className="btn btn--ghost">
              Get in touch
            </a>
          </div>

          <div className="hero__socials">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="hero__social"
                aria-label={social.name}
              >
                <img src={social.icon} alt={social.name} />
              </a>
            ))}
          </div>
        </div>

        <div className="hero__card-wrap">
          <div className="code-card">
            <div className="code-card__bar">
              <span className="code-card__dot code-card__dot--r" />
              <span className="code-card__dot code-card__dot--y" />
              <span className="code-card__dot code-card__dot--g" />
              <span className="code-card__file">developer.js</span>
            </div>
            <pre className="code-card__body">
              <code>
                <span className="tok-kw">const</span> <span className="tok-var">developer</span>{' '}
                <span className="tok-op">=</span> <span className="tok-p">&#123;</span>
                {'\n'}  <span className="tok-key">name</span>
                <span className="tok-p">:</span> <span className="tok-str">'Sibi Sebastian'</span>
                <span className="tok-p">,</span>
                {'\n'}  <span className="tok-key">stack</span>
                <span className="tok-p">:</span> <span className="tok-p">[</span>
                <span className="tok-str">'Node.js'</span>
                <span className="tok-p">,</span> <span className="tok-str">'React'</span>
                <span className="tok-p">,</span> <span className="tok-str">'MongoDB'</span>
                <span className="tok-p">,</span> <span className="tok-str">'MySQL'</span>
                <span className="tok-p">]</span>
                <span className="tok-p">,</span>
                {'\n'}  <span className="tok-key">focus</span>
                <span className="tok-p">:</span> <span className="tok-str">'APIs & full-stack apps'</span>
                <span className="tok-p">,</span>
                {'\n'}  <span className="tok-key">location</span>
                <span className="tok-p">:</span> <span className="tok-str">'Karnataka, IN'</span>
                <span className="tok-p">,</span>
                {'\n'}  <span className="tok-key">openToWork</span>
                <span className="tok-p">:</span> <span className="tok-bool">true</span>
                <span className="tok-p">,</span>
                {'\n'}
                <span className="tok-p">&#125;</span>
                <span className="tok-p">;</span>
              </code>
            </pre>
          </div>
        </div>
      </div>

      <a href="#about" className="hero__scroll" aria-label="Scroll to about section">
        <span className="hero__scroll-line" />
        scroll
      </a>
    </section>
  );
};

export default Hero;
